import CampaignsService from 'services/campaignsService'

const StaffGetUploadedFileLink = async (
  filePath: string,
  getAuthToken: () => Promise<string>
): Promise<string | undefined> => {
  if (!filePath) return

  const token = await getAuthToken()

  

  const service = new CampaignsService(token)

  

  const result = await service.campaignsService.get(
    'StaffGetUploadedFileLink',
    {
      filePath,
    }
  )

  return result.data
}

export default StaffGetUploadedFileLink
